import React from 'react';
import {Flex} from '@components';
import {Button, Checkbox, Col, message, Modal, Radio, Row} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import './index.css';
import NHFetch from "@utils/NHFetch";
import createHistory from 'history/createHashHistory';
import {getLoginUser} from "@utils/NHCore";
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";

const history = createHistory();
const confirm = Modal.confirm;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mkbz: 'GD006_10',
      hjmc: '',
      nextUrl: '',//左侧菜单加载完后传进来
      search: '',
      operable: true,//是否显示环节
      nonOperationalData: {},//不可操作的数据
      blztFlag: "0",
      stuMap: {},
      ssxx: null
    };
  }


  componentDidMount() {
    // 查询床位信息
    this.getData();
    this.queryQztjAndYlhj();
  }

  getData = () => {
    NHFetch('/yzgy/getCwxx', 'GET').then(res => {
      if (res && res.data) {
        this.setState({stuMap: res.data.stuMap, ssxx: res.data.ssxx})
        if (res.data.ssxx) {
          this.checkIsZzbdHjLinked();
        }
      }
    })
  }
  //检查该环节是否已经办理
  checkIsZzbdHjLinked = () => {
    let xsid = getLoginUser() ? getLoginUser().userId : '';
    let zzbdhjid = this.getUrlParams('pkid');

    NHFetch("/zzbdCommon/checkIsZzbdHjLinked", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
        .then(res => {
          if (res && res.code === 200) {
            if (!res.data) {
              this.commonSaveLinkTransactionStatus();
            }
          } else {
            message.error("查询环节办理状态失败，请稍后再试");
          }
        });
  };

  //自动办理
  commonSaveLinkTransactionStatus = () => {
    let xsid = getLoginUser() ? getLoginUser().userId : "";
    let zzbdhjid = this.getUrlParams("pkid");
    let params = {xsid: xsid, zzbdhjid: zzbdhjid};
    NHFetch("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(
        res => {
          if (res) {
            if (res.data === 1) {
              this.reloadMenu();
            }
          } else {
            message.error("自动办理缴费环节失败，请稍后重试！");
          }
        }
    );
  };
  xcym = () => {
    NHFetch('/yzgy/getXcym', 'GET').then(res => {
      if (res && res.data) {
        window.open(res.data, "_blank");
      } else {
        message.error("请求出错！请联系管理员")
      }
    })
  }
  //查询前置条件和依赖环节
  queryQztjAndYlhj = (callback) => {
    let xsid = getLoginUser() ? getLoginUser().userId : '';
    if (!xsid) {
      this.setState({
        nonOperationalData: {nologin: true},
        operable: false,
      });
      return;
    }
    let zzbdhjid = this.getUrlParams('pkid');
    NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
        .then(res => {
          if (res && res.data) {
            let kfsj = res.data['kfsj'];
            let ylhj = res.data['ylhj'];
            let qzhj = res.data['qzhj'];
            let nohj = res.data['nohj'];
            this.setState({nonOperationalData: res.data});
            if (kfsj && kfsj['YXSJ'] != '1') {
              this.setState({operable: false});
            }

            if (ylhj && ylhj.length > 0) {
              this.setState({operable: false});
            }

            if (qzhj && qzhj.length > 0) {
              this.setState({operable: false});
            }
            if (nohj) {
              this.setState({operable: false});
            }
            if (callback) {
              callback(this.state.operable);
            }
          }
        });
  };

  setMenuList = (menuList) => {
    let nextCount = 0;
    let bz = this.state.mkbz;
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC;
        let blztFlag = elem.BLZT;
        this.setState({hjmc, blztFlag})
        nextCount = index + 1;
        return;
      }
    });
    let menu = menuList[nextCount];
    if (menu) {
      let hjdm = menu.HJDM;
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm];
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID,
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = "/customLink";
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: '',
      })
    }
  }

  //获取url中传递的参数
  getUrlParams = (param) => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  };


  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }


  render() {
    const {blztFlag, stuMap, ssxx} = this.state;
    return (
        <div>
          {this.state.operable ?
              <Flex className="w1180 mt-20" align="start">
                <SiderMenu
                    ref={"siderMenu"}
                    setMenuList={this.setMenuList}
                    title="自助报到"
                    mkbz={this.state.mkbz}
                    menuType="自助报到"
                />
                <Flex.Item className="page_con_r" styleName="">
                  <Breadcrumb
                      noLine
                      list={[
                        {name: '首页', url: '/index'},
                        {name: '自助报到', url: '/register'},
                        {name: this.state.hjmc}
                      ]}
                  />
                  <div className="box">
                    <Hint/>
                    <TitleTop
                        className="mt-20"
                        title={this.state.hjmc}
                        extra={false}
                    >
                    </TitleTop>
                    <div style={{textAlign: 'center', fontSize: '20px', marginTop: "20px"}}>
                      <Button type={"primary"} onClick={this.xcym}>选床页面</Button>
                    </div>
                    <div style={{marginTop: "10px"}}>
                      <Row>
                        <Col
                            style={{textAlign: "center", padding: "10px"}}
                            span={8}
                        >
                          学号：{stuMap ? stuMap.XH : ""}
                        </Col>

                        <Col
                            style={{textAlign: "center", padding: "10px"}}
                            span={8}
                        >
                          姓名：{stuMap ? stuMap.XM : ""}
                        </Col>
                        <Col
                            style={{textAlign: "center", padding: "10px"}}
                            span={8}
                        >
                          公寓楼栋：{ssxx ? ssxx.gy : ""}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                            style={{textAlign: "center", padding: "10px"}}
                            span={8}
                        >
                          房间号：{ssxx ? ssxx.fj : ""}
                        </Col>
                        <Col
                            style={{textAlign: "center", padding: "10px"}}
                            span={8}
                        >
                          床位号：{ssxx ? ssxx.cw : ""}
                        </Col>
                      </Row>
                    </div>
                    <div className="text-center mt-50">
                      <Button className="ml-10" type="primary" ghost>
                        {blztFlag == '0' ? '未办理' : '已办理'}
                      </Button>
                      <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                    </div>
                    <style jsx="true" global="true">
                      {`
                          .ant-result-title {
                              font-size: 20px !important;
                          }
                      `}
                    </style>
                  </div>
                </Flex.Item>
              </Flex> : <CommonTip hjmc={"自选宿舍"} key={'GD006_10'} mkbz='GD006_10'
                                   nonOperationalData={this.state.nonOperationalData}/>}
        </div>
    );
  }
}
